export const screenName = 'FundsRedemption';
